<!DOCTYPE html>
<html lang="tr">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">

<title>{{ seo.docTitle }}</title>
<meta name="description" content="{{ seo.description }}">
<meta name="robots" content="index, follow, max-image-preview:large">
<link rel="canonical" href="{{ canonical }}">

<meta property="og:type" content="website">
<meta property="og:site_name" content="Frawgraphy">
<meta property="og:locale" content="tr_TR">
<meta property="og:url" content="{{ canonical }}">
<meta property="og:title" content="{{ seo.ogTitle }}">
<meta property="og:description" content="{{ seo.ogDescription }}">
<meta property="og:image" content="{{ seo.ogImage }}">
<meta name="twitter:card" content="summary_large_image">

<link rel="icon" href="/favicon.ico" sizes="any">
<link rel="icon" type="image/png" sizes="32x32" href="/assets/img/favicon-32.png">
<link rel="icon" type="image/png" sizes="16x16" href="/assets/img/favicon-16.png">
<link rel="apple-touch-icon" sizes="180x180" href="/assets/img/apple-touch-icon.png">
<link rel="manifest" href="/site.webmanifest">

<meta name="theme-color" content="#060606" media="(prefers-color-scheme: dark)">
<meta name="theme-color" content="#f5f3f0" media="(prefers-color-scheme: light)">

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;0,6..96,700;0,6..96,900;1,6..96,400;1,6..96,700&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap">
<link rel="stylesheet" href="assets/css/style.css?v=20260920b">
<noscript><style>.reveal{opacity:1;transform:none}</style></noscript>

<script>
  (function () {
    try {
      var t = localStorage.getItem('frawgraphy-theme');
      if (!t) t = matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', t);
      document.documentElement.setAttribute('data-lang', localStorage.getItem('frawgraphy-lang') || 'tr');
    } catch (e) {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.documentElement.setAttribute('data-lang', 'tr');
    }
  })();
</script>
</head>
<body data-title-key="album.docTitle">

<a class="skip-link" href="#main" data-i18n="skip">İçeriğe geç</a>

{{> header }}

{{> menu }}

<main id="main" class="page">
  <div class="shell">

    <nav class="crumbs" aria-label="Site yolu">
      <ol>
        <li><a href="index.html" data-i18n="blog.crumbHome">Ana sayfa</a></li>
        <li><a href="works.html" data-i18n="works.crumb">Bütün işler</a></li>
        <li aria-current="page" data-i18n="album.crumb">{{ title }}</li>
      </ol>
    </nav>

    <header class="page-head">
      <p class="section-index" data-i18n="album.index">Albüm — {{ count }} kare, {{ year }}</p>
      <h1 class="page-title" data-i18n-html="album.title">{{{ titleHtml }}}</h1>
      <p class="section-lede" data-i18n="album.lede">
        {{ lede }}
        Kadraja tıklayın — kare tam çözünürlükte açılır, alttaki şeritten seride gezinin.
      </p>
    </header>

    <ul class="works-grid" data-digital>
{{#each photos}}
      <li class="works-item reveal" style="--r:{{ r }};--s:{{ s }}">
        <a href="{{ full }}" data-digital-hit aria-label="{{ zoomAria }}">
          <img src="{{ browse }}" alt="{{ alt }}" width="{{ width }}" height="{{ height }}" loading="lazy" decoding="async">
          <span class="works-meta">
            <span class="works-cat">{{ @pad }}</span>
            <span class="works-year">{{ year }}</span>
          </span>
        </a>
      </li>
{{/each}}
    </ul>

      {{> lightbox }}

    <aside class="page-cta reveal">
      <h2 data-i18n="works.cta.title">Sıradaki seri sizin olabilir</h2>
      <p data-i18n="works.cta.text">Takvimimiz iki ay önceden dolar. Tarih ve kapsamı yazmanız yeterli.</p>
      <a class="btn btn--primary" href="index.html#contact">
        <span data-i18n="blog.cta.btn">Çekim planla</span>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </a>
    </aside>
  </div>
</main>

{{> footer }}

<script src="assets/js/i18n.js?v=20260920b" defer></script>
<script src="assets/js/main.js?v=20260920b" defer></script>
</body>
</html>
